<template>
  <div class="content">
    <Headline :level=2 styling="page-title">Die Chronik der Garde</Headline>
    <Separator/>
    <Headline :level=2 styling="page-title">Prolog</Headline>
    <Paragraph>Im Jahre 1753 lies Graf Friedrich Alexander zu Wied durch seinen Bruder Ludwig Carl
      das Militär
      seiner Grafschaft neu zuordnen. Dabei entstand auch die „Grenadierkompanie im
      Infanterieregiment“, das
      historische Vorbild der heutigen Ehrengarde, deren Uniformen diese, dem Original getreu trägt.
      Diese Chronik kommt in einer neuen Form daher, nach einer kurzen Darstellung der Grundlagen
      werden die
      Ereignisse in Blöcken geschildert, die- getreu der karnevalistischen Zahlenfolge- immer 11
      Jahre umfassen.
      Viel Spaß beim Eintauchen in die Geschichte der Ehrengarde Neuwied.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Gründung</Headline>
    <Paragraph>Im Rahmen der 300-Jahr Feier der Stadt Neuwied im Jahre 1953 wurde ein großer
      Festumzug durch die
      Stadt geplant. Ein Wagen stellte Fürst Friedrich Alexander zu Wied dar. Als Begleitung dieses
      Wagens sollten
      einige junge Männer mit originalgetreuen Uniformen der 1. wiedischen Grenadiere von der Stadt
      Neuwied
      ausgestattet werden. Nach dem Umzug überlegte man, was mit den schönen Uniformen nun geschehen
      sollte. Bei
      Wirt Kurt Haag - einem gebürtigen Kölner- in der Deichkrone, entstand die Idee die Ehrengarde
      im
      karnevalistischen Sinne zu gründen. Da das Interesse die Uniformen zu tragen bei der
      ursprünglichen
      Mannschaft schwand, wurde ab 1954 die Schwimmmannschaft des NWV (Neuwieder Wassersport Verein)
      mit ins Boot
      geholt. Diese begleitete uniformiert den Festausschuss der Stadt Neuwied bei offiziellen
      Terminen.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Die Jahre von 1953-1964</Headline>
    <Paragraph>Schon in ihrem Gründungsjahr startete am 03. Februar 1954 die erste Sitzung in der
      Deichkrone, die
      besonders von Amanda Kaiser, Abba Kleinmann, Ossi Imhoff und Kurt Haag gestaltet wurde. Die
      Neuwieder
      Stadtzeitung schrieb am 5. Februar: „….dass der Abend in der Deichkrone zu einem Höhepunkt in
      der Session
      wurde.“ Ab dem 1. Jahr fand das Eintopfessen der Ehrengarde an Karnevalssonntag im Bootshaus
      statt.
      Der Festausschuss kümmerte sich um die noch junge Ehrengarde beispielsweise durch die
      Kostenübernahme von
      40,10 DM für 27 Mittagessen, … „da der Ehrengarde an den Karnevalstagen eine Sondersammlung
      untersagt worden
      war…“. Dies geht aus einer Aktennotiz hervor. Schon bald wurde die Ehrengarde finanziell auf
      eigene Füße
      gestellt. Dies geht z.B. aus der Endabrechnung der Veranstaltung vom 23.Januar 1960 hervor. Im
      NWV-Bootshaus
      führte die Garde unter Christel Haack und Karl Dasbach eine „öffentliche Tanzlustbarkeit“
      durch. Im Jahr
      1960 wurde auch der erste Versuch unternommen, ein „Alt-Herren-Corps“ bewährter Karnevalisten
      in der
      Ehrengarde zu installieren. Hierzu lud Festausschusspräsident Dasbach zu einer Sitzung am
      02.Dezember 1960
      ein. Teilnehmer waren z.B. die späteren Ehrenoffiziere Otto Winnen, Abba Kleinmann, Hans
      Schätzle und Otto
      Kind. Von Seiten der Ehrengarde nahmen Hans-Christel Haack und Wilfried Pillen teil. Doch dies
      klappte
      nicht so wie man sich das vorstellte. Das Interesse schwand zusehends und so war Friedhelm
      Wolf erst einmal
      der letzte Kommandeur der Ehrengarde.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Die Jahre 1965-1974</Headline>
    <Paragraph>Im Jahre 1966 stöberte Erhard Nidrée, der Auszubildender bei der Stadtverwaltung war,
      dort auf dem
      Dachboden, auf der Suche nach Uniformen für den Rathaussturm, bei dem die Bediensteten der
      Stadtverwaltung
      damals noch das Rathaus selbst verteidigten. Dabei fand er einige Uniformen der Ehrengarde. Da
      das Interesse
      daran mäßig war, fragte er Robert Raab, Hans-Wilhelm Schaback und Dieter Krämer, ob sie
      Interesse an den
      Uniformen hätten. Diese erklärten sich bereit, sich den Uniformen anzunehmen und stöberten in
      der
      Geschichte. Sie belebten die Ehrengarde wieder, suchten noch weitere Uniformen zusammen und
      überredeten
      Freunde aus dem Stenographenverein sich zu beteiligen. Am 01.01.1967 starteten sie mit einem
      Auftritt von
      10 Mann, einem Offizier und einem Mariechen beim Bürgerverein Grün-Weiß. Otto Winnen, der
      damals Präsident
      des Festausschusses war unterstützte die junge Truppe bei organisatorischen Fragen und der
      Festausschuss
      unterstützte die Ehrengarde auch finanziell. 1969 fand die erste eigene Sitzung im Bootshaus
      statt. Im
      Sommer desselben Jahres marschierten die wiedischen Grenadiere beim Festumzug anlässlich der
      Stadternennung
      in Bad Hönningen. So motiviert bestritt die Ehrengarde nicht nur ihre eigene Sitzung ihm 10.
      Januar 1970,
      bei der Günter Kutscher erstmals in der Bütt stand, sondern trat auch außerhalb der Innenstadt
      in Irlich
      und sogar auf der anderen Rheinseite in Weißenthurm auf. Am 16. Januar 1971 war es wieder
      soweit,
      unter der Präsidentschaft von Otto Winnen fand die Sitzung der Ehrengarde im Bootshaus statt.
      Auch Micha
      Wertgen traute sich, wenn auch mit zitternden Knien, in die Bütt. Mittlerweile war die Garde
      18 Mann stark
      und absolvierte in der Session 1970/1971 24 Auftritte in und um Neuwied. Im Juni 1971 fand das
      erste
      Gardezeltlager am Breitenauer Weiher statt, aus Gründen des Datenschutzes kann dazu bis heute
      nichts Näheres
      preisgegeben werden. Am 08. Januar 1972 fand die Sitzung der Ehrengarde erstmals im Heimathaus
      statt.
      Trotz sorgenvoller Überlegungen von Robert Raab; „Wenn Heimathaus, dann stärkere Kapelle,
      überhaupt alles
      teurer, Redner müssen sich an großen Saal gewöhnen…“ (Aktennotiz von Robert Raab), gelang
      dieses Vorhaben,
      wie nicht anders zu erwarten, brillant. Da die Ehrengarde nun schon volljährig geworden war,
      entschied man
      sich dafür, in Zukunft alljährlich die erste Sitzung der Session im Heimathaus abzuhalten.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Die Jahre 1975-1985</Headline>
    <Paragraph>1975 fand unter dem Protektorat von Oberbürgermeister Schön am 22. September das
      22jährige Jubiläum
      im Leseverein statt. Im darauffolgenden Jahr stellte die Ehrengarde mit Robert I. und Ihrer
      Putzigkeit
      Gisela I. das Prinzenpaar, das am 24. Januar 1976 proklamiert wurde. Im Zuge der Proklamation
      von Robert
      Raab wurde dieser Von Michael (oder Micha) Wertgen als Kommandeur abgelöst. In der Sitzung am
      15. Januar 1977 bekam die
      Ehrengarde Unterstützung von der Gruppe 4 Asse und ein Joker. Der Auftritt wurde ein voller
      Erfolg und
      so wurde diese Gruppe auch in den folgenden Sitzungen ein fester Bestandteil des Programms.
      1980 wurde
      das Reservistencorps der Ehrengarde gegründet. Bei der Sitzung am 17. Januar 1981 verblüfften
      die aktiven
      Reservisten der Ehrengarde mit einer bis heute legendären Aufführung von Tschaikowskis
      Schwanensee. In den
      Folgejahren wuchs das Team der aktiven Reservisten immer mehr und so konnten Darbietungen wie
      „Das ist ihr
      Leben-Dr. Guter“, „Miss-City-Wahl“, „Ein Schärjer im Wunderland“ etc. das Publikum erfreuen.
      Im prinzenlosen
      Jahr 1982 sorgte die Ehrengarde mit ihrem „Prinzen von Rockenfeld“ bei den Offiziellen des
      Karnevals für
      Furore. 1984 trat zum ersten Mal das Piccolokorps der Ehrengarde auf und eroberte die Herzen
      des Publikums
      im Sturm. Ein historischer Meilenstein wurde auch mit dem ersten Auftritt der Garde auf einer
      Heimbacher
      Bühne gesetzt. Auch außerhalb der Karnevalszeit engagiert sich die Ehrengarde immer wieder
      gerne, so 1985
      für die „Aktion Sorgenkind- Stadt der guten Taten“. Zudem begann im gleichen Jahr die Karriere
      von Harald
      Schröder als „Singender Schärjer“.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Die Jahre 1986-1996</Headline>
    <Paragraph>1986 war wieder ein Jubiläumsjahr. Die Ehrengarde feierte ihren 3x11. Geburtstag.
      Traditionsgemäß
      stellte sie in diesem Jahr auch das Prinzenpaar der Stadt Neuwied mit dem damaligen Kommandeur
      Hans- Michael
      Wertgen und seiner Prinzessin Brigitte-Ursula Scherrer. Dank des tatkräftigen Einsatzes vieler
      Mitglieder
      konnten die Ornate für den gesamten Hofstaat erneut aus den Reihen der Garde selbst
      hergestellt werden.
      Zudem zeigten die Wagenbauer ihr ganzes Können und ein erster Traktor musste in mühevoller
      Arbeit
      hergerichtet werden. Er wurde WoPi getauft, nach seinem Paten Wolfgang Pierdolla. Da das
      Heimathaus 1987
      und 1988 neu gebaut wurde, nahm der Tanzsportverein die Ehrengarde netterweise auf und die
      Sitzungen fanden
      in der Rheinstraße statt. Ab 1989 konnte die Ehrengarde ihre Sitzungen im neu gestalteten
      Heimathaus
      fortführen. 1988 stellte die Ehrengarde zum ersten Mal einen eigenen Stand auf der IHAGA, als
      Garant für
      die rheinische Brauchtumspflege. Zu Ehren von „100 Jahre Karneval in Bad Hönningen“ nahm die
      Ehrengarde an
      einem Gardetreffen mit Biwak teil. 1990 fuhr eine erste Delegation zur Karnevalseröffnung in
      die
      Partnerstadt Güstrow. Bis heute besteht die Freundschaft zum Güstrower Carnevals Club (GCV).
      1990 stand
      unser aktueller Prinz Markus Schröder zum ersten Mal als „Der Protokoller“ in der Bütt. 1991
      wurde ein
      weiteres Fahrzeug für den stetig wachsenden Fuhrpark angeschafft. Nach gründlicher Renovierung
      wurde es auf
      den Namen JuHe getauft, nach seinen Paten Justus und Helga Reiprich. Die Freundschaft zu
      unserer Partnerstadt
      Güstrow wurde intensiviert, als 1992 20 Gäste am Pfingstzeltlager der Ehrengarde teilnahmen.
      Außerdem nahm
      die Ehrengarde zum zweiten mal am Rheinland- Pfalz Tag teil, diesmal in Ludwigshafen. Weitere
      Teilnahmen am
      Rheinland-Pfalz Tag fanden später noch in Neuwied (1993), in Andernach (1996) und in Pirmasens
      (1997) statt.
      1993 war die Ehrengarde zum 1125jährigen Bestehen von Leutesdorf im Winzerzug vertreten. 1994
      war ein sehr
      prägendes Jahr für die Ehrengarde. In einer Sitzung am 26.08.1994 wurde sowohl die Neugründung
      der
      Ehrengarde, als auch ihr Eintrag in das Vereinsregister beschlossen. Der erste Vorstand des
      neu gegründeten
      Vereins: Präsident: Michael Wertgen, Vizepräsident: Günter Kutscher, Geschäftsführer: Reinhold
      Mohr,
      Schatzmeister: Hans- Wilhelm Schaback, Schriftführerin: Claudia Arenz. Beim 430jährigen
      Bestehen der
      Pfingstreiter war die Ehrengarde im großen Umzug als historische Garde vertreten. 1995 war die
      Ehrengarde
      auch außerhalb der Session sehr aktiv, so nahm sie mit einer großen Gruppe in historischen
      Gewändern am
      1000jährigen Bestehen Mecklenburgs in Güstrow teil. Am Neuwieder Radwandertag verdrängte die
      Ehrengarde
      als teilnehmerstärkste Truppe den bis dahin ungeschlagenen TV Heddesdorf von seinem Platz.
      1996 wurde der
      Garde die Ehre zu teil, der fürstlichen Hochzeit von Prinzessin Christina zu Wied beizuwohnen
      und in Uniform
      verschiedene Sicherheit- und Repräsentationsaufgaben zu übernehmen.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Die Jahre 1997-2007</Headline>
    <Paragraph>Im Jahre 1997 fanden die ersten Vorstandswahlen nach Eintragung in das
      Vereinsregister statt. Der
      neue Vorstand setzte sich wie folgt zusammen: Präsident: Günter Kutscher, Vizepräsident: Hans-
      Martin
      Schröder, Geschäftsführer: Gerd Schanz, Schatzmeister: Veit Schröder, Schriftführerin: Claudia
      Arenz. In
      diesem Jahr wurde das 4x11. Jubiläum der Ehrengarde gefeiert. Zunächst gab es ein Heerlager
      auf der Burg
      Altwied und dann einen Festakt im Neuwieder Kreismuseum. Das Prinzenpaar Prinz Mini I. von der
      Ehrengarde
      und Prinzessin Hannelore I. von Rat und Medien (Hannelore Gröhbühl) wurde am 10. Januar 1998
      proklamiert.
      Trotz Sonnenschein war die Stimmung am Rosenmontag dem 23.02. etwas getrübt. Wurde doch der
      schöne 4,30m
      hohe Prinzenwagen auf dem Weg zum Aufstellplatz an der nur 3,90m hohen Unterführung in der
      Blücherstraße
      vom Fahrer kurzerhand geköpft. Seither ist Prinz Mini I. auch als „Prinz Cabrio“ bekannt. Am
      25. April 1998
      war die Garde mit ihren Uniformen wieder Gast im Fürstenschloss, als sich nun S.D. Carl Prinz
      zu Wied und
      I.D. Isabelle Prinzessin zu Isenburg das Ja-Wort gaben. Im November 1998 besuchte das
      Prinzenpaar wieder
      die Karnevalseröffnung in Güstrow und trat in vollem Ornat auf die Bühne. 1999 wurde der
      Beginn der
      traditionellen Sitzung der Ehrengarde am 16. Januar erstmals auf 19.11 Uhr vorverlegt. Der
      langjährige
      Sitzungspräsident Fredi Winter wurde zum Ehrenoffizier der Ehrengarde ernannt. Im Juni dieses
      Jahres hatte
      die Ehrengarde einen „tierischen“ Auftritt. Unter dem Motto „Eine Besuch em Zoo“ nahm die
      Ehrengarde am
      Rheinland-Pfalz Tag in Boppard teil, allerdings nicht in den gewohnten Uniformen, sondern als
      Tiere
      verkleidet. In der Milleniumssitzung der Ehrengarde im Jahre 2000 wurden gleich drei neue
      Ehrenoffiziere
      ernannt. Mit Bürgermeister Nikolaus Roth, Pastor Norbert Kohns und Hans Kalter von der Nette-
      Brauerei
      waren nun die drei wichtigsten Lebenszweige: Politik, Kirche und Grundnahrungsmittel
      abgedeckt. S.D.
      Friedrich Wilhelm zu Wied wurde 2000 der „Goldene Schärjer“ verliehen. Natürlich durfte da
      seine Ehrengarde
      beim Festakt nicht fehlen. Bei glühender Hitze nahm die Ehrengarde am 24. Juni 2001 am
      Festumzug des 5. RKK
      Tages in Ulmen teil. In diesem Jahr gab es beim Pfingstzeltlager in Bonefeld hohen Besuch von
      S.D. Carl zu
      Wied, der es sich nicht nehmen ließ seinen Truppen im Sommerquartier einen Besuch abzustatten.
      Am 01.
      November 2001 fand in Heimbach-Weis die „Welt größte Clownparade“ statt, bei der auch die
      Ehrengarde nicht
      fehlen durfte. 2002 durfte Günter Kutscher bei seiner Verleihung des Neuwieder Narrensterns
      sogar mit
      Marie-Luise Marjan, der Mutter Beimer aus der Lindenstraße, „Stippefötche“ tanzen. Sie bekam
      damals den
      goldenen Schärjer verliehen. Zum Ehrenoffizier wurden in diesem Jahr Horst Protz (Coca-Cola)
      für seine
      Verdienste bei den Piccolos und Jürgen Klappert ernannt. Leider verstarb in diesem Jahr auch
      der
      dienstälteste Ehrenoffizier Otto Kind, seine Nachfolge als Kommandeur des Ehrenoffiziercorps
      trat
      Hans-Wilhelm Schaback (bis heute) an. Ein ganz besonderes Jahr war 2003, galt es doch gleich
      drei Jubiläen
      zu feiern. Die Stadt Neuwied feierte ihren 350. Geburtstag, die wiedischen Grenadiere wurden
      250 Jahre alt
      und die Ehrengarde durfte ihr 50. Jubiläum begehen. Aufgrund dieser drei Ereignisse
      veranstaltete die
      Ehrengarde erstmals einen historischen Markt im Schlosshof des Neuwieder Fürstenschlosses. Es
      wurde ein
      voller Erfolg, von dem bis heute noch gerne berichtet wird. Außerdem fand anlässlich der 350
      Jahr Feier der
      Stadt auch der 6. RKK Tag in Neuwied statt, bei dessen Festumzug die Ehrengarde als einer der
      teilnehmerstärksten Neuwieder Karnevalsvereine teilnahm. Ehrenoffizier und inzwischen
      Oberbürgermeister der
      Stadt Neuwied Nikolaus Roth wurde mit dem goldenen Schärjer ausgezeichnet. Das Jahr 2004
      startete mit 2
      Premieren: Als Sitzungskapelle fungierte erstmals die Tanz- und Showband Carricon, die uns
      viele Jahre
      begleitet hat. Außerdem stieg Sören Schröder, der Sohn unseres langjährigen Protokollers
      Markus Schröder
      zum ersten Mal in die Bütt, um die Familientradition im Hause Schröder fortzuführen. Zum
      Ehrenoffizier wurde
      Metzgermeister Karl Schumacher, unser Haus- und Hoflieferant, ernannt. Mit dem goldenen
      Schärjer wurde
      wiederum ein Ehrenoffizier, nämlich Klaus Pinkemeyer von der Sparkasse Neuwied ausgezeichnet.
      Das Jahr 2005
      startete gleich in der Sitzung der Ehrengarde mit einem Highlight: Die „Singenden
      Kellermeister“ aus
      Mainz-Kastell waren zu Gast und sorgten für ein gelungenes Finale. Unser Bühnenduo „Mini und
      Windi“ bekam
      Zuwachs von Roberto (Robert Raab) und wechselten die Rollen, indem sie ihr Leben aus Sicht
      ihrer Ehefrauen
      darstellten. Ehrenoffiziere wurden in diesem Jahr Achim Ströder und Gerd Schneider. Der als
      „Ruhrkumpel“
      weithin bekannte Hans- Martin Schröder wurde mit dem Narrenstern des Narrenclubs Grün-Rot
      Neuwied
      ausgezeichnet. Auf dem Weihnachtsmarkt ließ es sich die Ehrengarde nicht nehmen vor dem
      Schlosstheater den
      Verkauf von Weihnachtsbäumen aus den fürstlich-wiedischen Wäldern zu übernehmen. 2006 startete
      die
      Ehrengarde mit dem von Präsident Günter Kutscher kreierten Sitzungsmotto „Karneval ist
      wunderschön, auch
      ohne Prinz und Obermöhn“ in die Session. Im Mai war die Ehrengarde beim Katholikentag in
      Saarbrücken und
      vertrat das Dekanat Rhein-Wied, indem sie die Gäste sehr erfolgreich mit heimischem
      Wildgulasch versorgte.
      Für einige Lacher sorgte es, dass im „Paulinus“ im Nachgang nochmal der Unterschied zwischen
      Manfred
      Wertgen, damaliger Kommandeur und dem Bischof Reinhard Marx erläutert werden musste. In diesem
      Jahr wurde
      in Weißenthurm auch das Priesterjubiläum von Norbert Kohns, unserer KaSak (Katholische
      Sündenabwehrkanone)
      gefeiert. Selbstverständlich war die Ehrengarde beim Festgottesdienst dabei und sorgte
      anschließend für die
      Bewirtung der Gäste. In der Sitzung am 13.01.2007 spielte der Geländerverein aus dem Lied von
      „Wittmann´s Ann“ eine große Rolle. Zudem gab das „Gardeorchester“ mit Gerd Schanz und Gisbert
      Fischer an den
      Teufelsgeigen und Hans-Wilhelm Schaback an der dicken Trumm sein Debüt und spielte sich
      schnell in die
      Herzen der Zuschauer. Als Ehrenoffizier wurde Georg Schuhen ernannt. Zudem trat die Ehrengarde
      auch
      außerhalb der Session beim Engerser Convent und anlässlich der 600-Jahr- Feier von Rengsdorf
      in Uniform in
      Erscheinung.
    </Paragraph>
    <Separator/>
    <Headline :level=2 styling="page-title">Die Jahre 2008-2019</Headline>
    <Paragraph>Das Jubiläumsjahr 2008 startete mit der Sitzung am 12.Januar, bei der Heinz-Peter
      Gütler neuer
      Ehrenoffizier wurde. Durch die schwere Krankheit von Manuela Kutscher, die auch wenige Tage
      später leider
      verstarb, war die ganze Veranstaltung stark beeinflusst. Der Ehrengarde stand nach diesem
      schlimmen Ereignis
      der Sinn nicht mehr nach Karneval und so wurden alle weiteren Auftritte und die Teilnahme am
      Rosenmontagszug
      in diesem Jahr abgesagt. Das Jubiläum brachte uns am 31.Mai wieder einen historischen Markt im
      Schlosshof,
      der wieder mit einem „Großen Zapfenstreich“ fulminant endete. Parallel wurde in der Sparkasse
      Neuwied eine
      Jubiläumsausstellung mit dem Thema „Brauchtum und Historie“ festlich eröffnet. Der Festakt zu
      5x11 Jahre
      Ehrengarde Neuwied wurde im Schlosstheater begangen. Mit der Proklamation des gardeeigenen
      Prinzenpaares
      Gerd I. vom Hause Neoweda, Herr von Langendorf und Sonnenland und seiner Prinzessin Ulrike II.
      von
      Landsberg/Kettwig zu Rhenania Neoweda fand das Jahr seinen Abschluss. Der „Ball am Hofe des
      Prinzen“ fand
      nämlich am 14.November 2008 im Heimathaus statt und ließ so manchen das Tanzbein zu den
      Klängen von
      „Carricon“ schwingen. Krönender Abschluss des Prinzenjahres war 2009 eine 3tägige Fahrt in die
      Partnerstadt
      Güstrow, wo das gesamte Prinzengefolge und eine große Abordnung der Ehrengarde im Namen von
      Oberbürgermeister Nikolaus Roth die Glückwünsche zum 20jährigen Bestehen der
      Städtepartnerschaft überbrachte.
      Das Jahr 2010 startete etwas ruhiger mit der Sitzung am 16.Januar, bei der Ralf Seemann, der
      Fraktionsvorsitzende von Bündnis 90/ Die Grünen, zum Ehrenoffizier ernannt wurde. Der
      Geländerverein wurde
      in diesem Jahr von Robert Raab und Günter Kutscher alleine aufgeführt, da Fredi Winter
      erkrankt war. Leider
      gab es wieder Anlass zur Trauer, denn Ecki Domschke, ein Neuwieder Original und ein treuer
      Freund der
      Ehrengarde verstarb viel zu früh und hinterließ als DJ eine große Lücke. 2011 wurde Peter Hof
      vor der Sitzung
      in das Ehrenoffizierskorps aufgenommen. Zum ersten Mal trat die Traumtänzerkompanie in der
      Sitzung auf, das
      Motto lautete „ABBA is back“. Die Ehrengarde unterstützte die Stadt bei der Ausrichtung der
      Deutschen
      Radsportmeisterschaften. Leider wurde die Auflösung des Freundeskreises Neuwied-Güstrow e.V.
      im Oktober
      beschlossen und der langjährige Fähnrich der Garde, Günter Kluge verstarb viel zu früh im
      Alter von 64
      Jahren. Das Jahr 2012 startete direkt turbulent mit dem Neujahrsempfang des
      Ministerpräsidenten Kurt Beck
      in Neuwied. Die Ehrengarde stand mit Fackeln Spalier am roten Teppich, über den zahlreiche
      Prominente
      flanierten. Leider sollte dies ein Highlight des Abends bleiben, bei dem es etliche technische
      Pannen im
      Heimathaus gab. Im Rahmen der Sitzung, die unter dem Motto „Musik ist Trumpf“ stand, wurde
      Marc Bohr zum
      Ehrenoffizier ernannt. Im Februar trat Michael Mang, später Beigeordneter und heute unser
      Bürgermeister in
      das aktive Korps der Ehrengarde ein und schwang fortan das Tanzbein, sobald es seine Zeit
      zuließ. Beim
      Rheinland-Pfalz Tag in Ingelheim marschierte die Ehrengarde ebenso wie bei der 1050-Jahrfeier
      in Heddesdorf.
      Unter dem Motto „Ehrengarde hautnah erleben“ präsentierte sich die Garde beim Maiflohmarkt.
      Dank zahlreicher
      Aktionen bei den Festen der Stadt konnten einige Neumitglieder geworben werden. Manfred
      Wertgen wurden für
      sein vielfältiges Engagement in der Garde gleich zwei Ehrungen zuteil. Zum einen wurde er mit
      der Ehrennadel
      des Landes Rheinland-Pfalz von Rainer Kaul geehrt, zum anderen wurde ihm der Narrenstern vom
      Narrenclub
      Grün-Rot verliehen. 2013 stand die Sitzung unter dem Motto „Schiff AHOI“. Zudem fand wieder
      ein
      „Historisches Forum Neoweda“ (als historische Marktveranstaltung) im Schlosshof statt. Die
      Ehrengarde
      übernahm die Patenschaft für zwei neue Orgelpfeifen in der Marktkirche. 2014 fand die Sitzung
      unter dem
      Motto „Hoi hoi hoi, wij danse moj! Für Holland hat’s zwar nicht gereicht, doch auch Neuwied
      ist
      eingedeicht!“ statt. Es wurden als neue Ehrenoffiziere Dieter Will und Rolf Blum ernannt.
      „Regimentsarzt“
      Karl Baum hatte beim Rosenmontagszug für Fußlahme einen Planwagen samt Zugmaschine
      organisiert. Beim
      Festumzug des Rheinland-Pfalz Tages in Neuwied musste allerdings wieder marschiert werden. Das
      Jahr 2015
      wurde mit der Sitzung unter dem Motto „Das ganze Leben ist ein Quiz“ eröffnet. Auch das
      Ehrenoffizierskorps
      bekam Zuwachs, hier wurde Herbert Meyer aufgenommen. Rainer Tross, unser langjähriger
      Zeugmeister, der sich
      liebevoll um die Instandhaltung des Fuhrparks kümmert wurde völlig zurecht mit dem Zinnhannes-
      Kulturpreis
      in der Kategorie „Hintergrund“ ausgezeichnet. Im Juli nahm die Ehrengarde bei sengender Hitze
      am
      Trachtenumzug in Kröv an der Mosel teil. In der Offiziersrunde fand ein großer Wechsel zur
      jüngeren
      Generation statt. So löste Alexander Baum Manfred Wertgen als langjährigen Kommandeur ab,
      Alexander Wertgen
      wurde anstelle von Markus Schröder stellvertretender Kommandeur, Melanie Gutfrucht löste Beate
      Tross als
      Kommandeure ab und Sören Schröder wurde anstelle von Marcel Thran neuer Spieß. Lediglich
      Michael Krämer
      behielt seinen Posten als Zahlmeister. Jedoch sollten wir einige der „alten Hasen“ aus der
      Offiziersrunde
      bei den Vorstandswahlen wiedersehen. Präsident wurde Markus Schröder, Manfred Wertgen
      fungierte als
      Vizepräsident und Marcel Thran wurde Geschäftsführer. Schatzmeister wurde Michael Krämer und
      Schriftführerin
      Stefanie Kugler. Als Beisitzerin stand nun Michaela Bayer zur Verfügung. Leider brachte das
      Jahr nicht nur
      Gutes und so war die Ehrengarde gefordert, als im März plötzlich und unerwartet S.D. Carl
      Fürst zu Wied im
      Alter von nur 53 Jahren verstarb. 2016 begann das Jahr mit der Sitzung unter dem Motto
      „Ein verrückter Schultag“. Nach 47 Jahren Mitgliedschaft und 18 Jahren als Präsident wurde
      Günter (Mini)
      Kutscher zum Ehrenoffizier ernannt, ebenso wie Karl Baum, der Regimentsarzt. Zum goldenen
      Priesterjubiläum
      unseres Ehrenoffiziers Norbert Kohns, ließ es sich die Garde nicht nehmen dem Jubilaren mit
      Böllerkanonier
      Karl Baum und seiner Kanone nach dem Gottesdienst kräftig einzuheizen. Beim Rheinland-Pfalz
      Tag in Alzey
      marschierte die Ehrengarde mit. 2017 stand die Sitzung unter dem Motto „Im Himmel ist der
      Teufel los!“.
      Passend zu diesem Motto bekam das Ehrenoffizierskorps geistlichen Zuwachs. Nachdem die
      Katholiken schon
      lange vertreten waren, erklärte sich nun auch Pfarrer Werner Zupp bereit die evangelische
      Seite würdevoll
      zu vertreten. Aufgrund der Tatsache, dass Rainer und Beate Tross im Hofstaat des
      Heimbach-Weiser Prinzen
      vertreten waren, kam dieser nicht umhin, sich eine Teilnahme der Ehrengarde am
      Veilchendienstagszug
      ausdrücklich zu wünschen. Daher kamen wir diesem Wunsch natürlich gerne nach, auch wenn die
      Wünsche aus
      Heimbach-Weis sonst keine Beachtung finden. Bei der 750-Jahr Feier in Melsbach durfte die
      Ehrengarde
      erfahren, dass es auch in so einem beschaulichen Dörfchen unendlich viele Straßen gibt, durch
      die man
      marschieren kann. Günter Kutscher wurde mit der Ehrennadel des Landes Rheinland-Pfalz
      ausgezeichnet.
      Zum 18. Geburtstag von S.D. Fürst Maximilian zu Wied war die Ehrengarde für ihren neuen
      Dienstherrn vor und
      im Schloss aktiv. Sehr tragisch und für alle schockierend verstarb im Juli Oberbürgermeister
      Nikolaus Roth
      ganz plötzlich. Mit ihm, dem die Ehrengarde stets am Herzen lag, verlor die Garde einen guten
      Freund und
      Gönner. Den Draht zur Stadt Neuwied behält die Ehrengarde aber weiterhin durch Michael Mang,
      der zum
      Bürgermeister gewählt wurde und weiterhin im aktiven Korps mitwirkt. das Jahr 2018 startete
      gleich mit
      einem karnevalistischen Jubiläum, fand nämlich im Heimathaus die nunmehr 50. Sitzung der
      Ehrengarde statt.
      Unter dem Motto „Kaffeefahrt zum Jungbrunnen“ wurde getanzt und viel gelacht. Robert Raab
      wurde als
      langjähriger Sitzungspräsident von Mini Kutscher und Fredi Winter abgelöst, die natürlich auch
      noch als
      Mini und Windi auf der Bühne standen. Als Ehrenoffizier wurde Bernd Maur „Maurs Bib Junior“
      ernannt. Um
      Bühnennachwuchs zu generieren fand im Big House erstmals der Wettbewerb „Neuwied geht in die
      Bütt“ statt,
      den auch prompt Hilde Herrlich, ein Supermodel in XXXL alias Stefanie Kugler gewann. Eine neue
      Offiziersrunde wurde gewählt: Alexander Wertgen zum Kommandeur, Thomas Kurz zum
      Vize-Kommandeur,
      Stefanie Kugler zur Kommandeuse, Bjarne Schröder zum Zahlmeister und Matthias Wertgen zum
      Spieß. Im
      Vorstand wurden alle in ihrem Amt bestätigt, lediglich Michaela Bayer gab ihr Amt zugunsten
      von Harry Ogrodnik
      ab. Jeder bekommt was er verdient und so bekamen in diesem Jahr Manfred Wertgen und Markus
      Schröder
      vom Festausschuss der Stadt Neuwied den Verdienstorden des Festausschusses in Gold für ihre
      langjährigen
      Verdienste in der Ehrengarde und im Neuwieder Karneval. 2019 startete mit der Sitzung unter
      dem Motto
      „Freunde fürs Leben“, in deren Rahmen Bürgermeister Michael Mang und nun endlich auch Manfred
      Wertgen in
      das Ehrenoffizierskorps aufgenommen wurden. Beim Sommerfest des Festausschusses wurde auch das
      künftige
      Prinzenpaar der Ehrengarde für das Jubiläumsjahr 6x11 Jahre vorgestellt. Am 17. August 2019
      findet im
      Schlosstheater die Feier zu diesem Jubiläum statt.
      Beim Sommerfest des Festausschusses wurde auch das künftige Prinzenpaar der Ehrengarde für das Jubiläumsjahr
      6x11 Jahre vorgestellt. Am 17. August 2019 fand im Schlosstheater die Feier zu diesem Jubiläum statt, die vom
      neuen Moderatorenteam der Garde, Stefanie Kugler und Alexander Wertgen hervorragend in Szene gesetzt wurde. Wie
      in jeder Jubiläumssession stellte die Garde mit Prinz Markus I. (Schröder) -Die spitze Feder von der Ehrengarde
      und Prinzessin Michaela I. (Bayer) vom Römerkastell am Wiedesstrand das Prinzenpaar der Stadt Neuwied. Die
      Proklamation am 09. November stand unter dem Motto "Ball am Hofe des Prinzen":
    </Paragraph>
    <Separator/>
    <SocialMedia/>
  </div>
</template>

<script>

import Separator from '../components/atoms/Separator.vue';
import Headline from '../components/atoms/Headline.vue';
import Paragraph from '../components/atoms/Paragraph.vue';
import SocialMedia from '../components/atoms/SocialMedia.vue';

export default {
  name: 'chronik',
  components: {
    SocialMedia,
    Paragraph,
    Headline,
    Separator,
  },
};
</script>
